// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles_swiper__rCjeZ","ar":"styles_ar__L8Wo0"};